import React from 'react'

type TabPanelProps = React.HTMLAttributes<HTMLDivElement> & {
  value: number
  index: number
}

// Always render the container so tabs' aria-controls target a real element; mount children only when active.
export const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
  return (
    <div
      {...other}
      aria-labelledby={`tab-${index}`}
      hidden={value !== index}
      id={`tabpanel-${index}`}
      role="tabpanel"
      style={{ padding: '0 1rem' }}>
      {value === index && children}
    </div>
  )
}
